import { render, staticRenderFns } from "./sendImage.vue?vue&type=template&id=28e616a0&scoped=true&"
import script from "./sendImage.vue?vue&type=script&lang=js&"
export * from "./sendImage.vue?vue&type=script&lang=js&"
import style0 from "./sendImage.vue?vue&type=style&index=0&id=28e616a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e616a0",
  null
  
)

export default component.exports